import React from 'react';

import { Popover } from 'antd';

import styled from 'styled-components';

const NotesBody = styled.div`
    margin: 0;
    max-width: 50rem;
    padding: 0.25rem .5rem 0.15rem .5rem;
    border-radius: 6px;
    border: 1px solid ${(props) => props.theme.LighterBorderColor};
    background: ${(props) => props.theme.LayoutBodyBackground};
    color: ${(props) => props.theme.TextColor};
    font-size: ${(props) => props.theme.FontSizeBase};
    line-height: 1.35;
    white-space: pre-wrap;
    word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: ${(props) => (props.$variant === 'card' ? 2 : 3)};
    -webkit-box-orient: vertical;
    overflow: hidden;
    cursor: ${(props) => (props.$clickable ? 'pointer' : 'default')};

    ${(props) =>
        props.$variant === 'card' &&
        `
        max-width: none;
        padding: 0;
        border: 0;
        background: transparent;
        color: #fff;
    `}
`;

const NotesPopoverContent = styled.div`
    max-width: 40rem;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.35;
    font-size: ${(props) => props.theme.FontSize};
`;

const SeasonModelNote = ({ notes, variant, onClick }) => {
    if (!notes) {
        return null;
    }

    const stopRowClick = (event) => {
        event.stopPropagation();
    };

    const handleClick = (event) => {
        if (onClick) {
            onClick(event);
            return;
        }

        stopRowClick(event);
    };

    const getPopupContainer = (triggerNode) => {
        if (variant === 'card') {
            return document.body;
        }

        return triggerNode.parentNode;
    };

    return (
        <Popover
            content={<NotesPopoverContent>{notes}</NotesPopoverContent>}
            trigger="hover"
            placement={variant === 'card' ? 'top' : 'topLeft'}
            overlayStyle={variant === 'card' ? { zIndex: 1060 } : undefined}
            getPopupContainer={getPopupContainer}
        >
            <NotesBody
                onClick={handleClick}
                onMouseDown={onClick ? undefined : stopRowClick}
                $variant={variant}
                $clickable={!!onClick}
            >
                {notes}
            </NotesBody>
        </Popover>
    );
};

export default SeasonModelNote;
